import { Helmet } from "react-helmet-async";

export default function Meta({
  title,
  description,
  keywords,
  canonical,
  jsonLd,
}) {
  const defaultTitle = "Airport Taxi & Pre-Booked Rides in Chandigarh, Mohali & Panchkula | Orbi";
  const defaultDescription = "Book reliable pre-booked airport taxis, office transport, and outstation rides in Chandigarh, Mohali & Panchkula. Transparent pricing, fixed fares, and professional partners.";
  const defaultKeywords = "airport taxi chandigarh, mohali airport cab, prebook taxi chandigarh, taxi service chandigarh mohali, reliable cab booking panchkula, fixed fare taxi, work transport booking";

  const pageTitle = title && title !== "" ? title : defaultTitle;
  const pageDescription = description || defaultDescription;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}

